// extracted by mini-css-extract-plugin
export default {"container":"TodoLists_container__G8QZs","todoBanner":"TodoLists_todoBanner__Ryz2J"};